import { render, staticRenderFns } from "./SundairLogin.vue?vue&type=template&id=73108c10&scoped=true"
import script from "./SundairLogin.vue?vue&type=script&lang=js"
export * from "./SundairLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73108c10",
  null
  
)

export default component.exports